import { Modal, notification } from 'antd';
import { useRemoveRouteMutation } from 'app/api';
import { handleError } from 'app/containers/Global/slice/helpers';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { useTaskSlice } from 'app/containers/Task/slice';
import { selectCheckedRouteIds } from 'app/containers/Task/slice/selectors';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

export const useRouteDelete = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const taskActions = useTaskSlice().actions;

  const checkedRouteIds = useSelector(selectCheckedRouteIds);
  const envId = useSelector(selectSelectedEnvId) as number;

  const [deleteRoute] = useRemoveRouteMutation();

  const onDeleteConfirm = async () => {
    try {
      await Promise.all(
        checkedRouteIds.map(routeId =>
          deleteRoute({ envId, routeId }).unwrap(),
        ),
      );
      notification.success({
        message: t(
          'Task.RouteDeleted',
          '{{count}} routes successfully deleted',
          {
            count: checkedRouteIds.length,
          },
        ),

        placement: 'bottomRight',
      });
      dispatch(taskActions.setCheckedRouteIds([]));
    } catch (error) {
      handleError(error);
    }
  };

  const onRouteDelete = () => {
    Modal.confirm({
      title: t(
        'Task.DeleteRoutesConfirm',
        'Are you sure you want to delete {{count}} routes?',
        { count: checkedRouteIds.length },
      ),
      onOk: () => onDeleteConfirm(),
      okText: t('Common.Yes', 'Yes'),
      cancelText: t('Common.No', 'No'),
    });
  };
  return { onRouteDelete };
};
